import React from 'react';
import styled from 'styled-components';
import '../../../homepage/cloud-features/style.css';
import '../../../Style/defaultstyle.css';
import '../../../Style/defaultstyle.scss'

function DetailContent() {

  return (
    <Box >
      <br /><br></br>
      <div>
        <div >
          <div >
            <div >
              <h2 style={StySpecification.Title} className='header'>VPC / 아이피 / 이메일 사용요금안내</h2>
            </div>
          </div>
          <div style={StySpecification.TableScroll}>
            <div style={StySpecification.TableWrap}>
              <div style={StySpecification.ListProduct}>
                <table width="100%">
                  <tbody >
                    <tr style={StySpecification.Header} className='sub-title'>
                      <td width="32%" style={StySpecification.BorLeft}><div style={StySpecification.TextTitle}><b>구분</b></div></td>
                      <td width="36%" ><b>내용</b></td>
                      <td width="32%" style={StySpecification.BorRight}><b>요금 (월)</b></td>
                    </tr>
                    <tr>
                      <td   style={StySpecification.TextLeft}>VPC 네트워크환경</td>
                      <td className="content_text" style={StySpecification.BorAll}>클러스터 시스템 구축용 독립 네트워크</td>
                      <td   style={StySpecification.BorAll}>10,000 원</td>
                    </tr>
                    <tr>
                      <td   style={StySpecification.TextLeft}>이메일발송(대용량메일사용불가)</td>
                      <td className="content_text" style={StySpecification.BorAll}>독립 이메일 인스턴스 구축</td>
                      <td   style={StySpecification.BorAll}>10,000 원</td>
                    </tr>
                    <tr>
                      <td   style={StySpecification.TextLeft}>아이피추가		</td>
                      <td className="content_text" style={StySpecification.BorAll}>1대의 가상서버 아이피 최대 3개추가	</td>
                      <td   style={StySpecification.BorAll}>3,000 원</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div >
          <div >
            <div >
              <h2 style={StySpecification.Title} className='header'>운영체제 및 데이터베이스 지원</h2>
            </div>
          </div>
          <div style={StySpecification.TableScroll}>
            <div style={StySpecification.TableWrap}>
              <div style={StySpecification.ListProduct}>
                <table width="100%" >
                  <tbody >
                    <tr style={StySpecification.Header} className='sub-title'>
                      <td width="32%" style={StySpecification.BorLeft}><div style={StySpecification.TextTitle}><b>구분</b></div></td>
                      <td width="45%" ><b>종류	</b></td>
                      <td width="23%" style={StySpecification.BorRight}><b>요금</b></td>
                    </tr>
                    <tr>
                      <td   style={StySpecification.TextLeft}>리눅스		</td>
                      <td   style={StySpecification.BorAll}><div style={StySpecification.KindLeft}>CentOS, Rocky Linux, Ubuntu, Debian</div></td>
                      <td   rowSpan="4" style={StySpecification.BorAll}>Microsoft<br />라이센스<br />요금정책별도</td>
                    </tr>
                    <tr>
                      <td   style={StySpecification.TextLeft}>윈도우		</td>
                      <td   style={StySpecification.BorAll}><div style={StySpecification.KindLeft}>Windows 2012~2019 Server (64비트)<br />
                        MS-SQL 2012 ~ 2019 Standard (64비트)</div></td>
                    </tr>
                    <tr>
                      <td   style={StySpecification.TextLeft}>데이터베이스</td>
                      <td   style={StySpecification.BorAll}><div style={StySpecification.KindLeft}>MySQL, PostgreSQL, Redis, MongoDB<br />
                        scyllaDB, Vitess, ClickHouse</div></td>
                    </tr>
                    <tr>
                      <td   style={StySpecification.TextLeft}>쿠버네티스 클러스터	</td>
                      <td   style={StySpecification.BorAll}><div style={StySpecification.KindLeft}>Nginx, Kong, Envoy, Kafka, ELK stack<br />
                        Kubernetes Database Cluster</div></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <br />
      </div>
    </Box>


  );
}


const StySpecification = {
  StylesContainer: {
    boxShadow: "0 0.375rem 1.5rem 0 rgb(140 152 164 / 13%)",
    border: "1px solid #E7EAF3",
    borderRadius: "8px",
    padding: 20,
    marginBottom: 30,
    marginTop: 30,
  },
  ListProduct: {
    paddingBottom: 20,
  },
  Title: {
    fontWeight: "bold",
    paddingBottom: 20,
    paddingTop: 10,
  },
  Header: {
    color: "white",
    background: "#393939",
  },
  TextTitle: {
    paddingTop: 8,
    paddingBottom: 8,
  },
  BorLeft: {
    borderTopLeftRadius: "8px",
    borderRight: "2px solid #F4F4F4",
  },
  BorRight: {
    borderTopRightRadius: "8px",
    borderLeft: "2px solid #F4F4F4",
  },
  BorAll: {
    borderLeft: "2px solid #DDDDDD",
    borderRight: "2px solid #DDDDDD",
    borderBottom: "2px solid #DDDDDD",
    paddingTop: 8,
    paddingBottom: 8,
  },
  KindLeft: {
    textAlign: "left",
    paddingLeft: 10,
  },
  TextLeft: {
    borderLeft: "2px solid #DDDDDD",
    borderRight: "2px solid #DDDDDD",
    borderBottom: "2px solid #DDDDDD",
    fontWeight: 900,
    textAlign: "left",
    paddingLeft: "10px"
  }
}

const Box = styled.div`
  
`

export default DetailContent;


